/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface McpConsentApprovalRequest
 */
export interface McpConsentApprovalRequest {
    /**
     * 
     * @type {string}
     * @memberof McpConsentApprovalRequest
     */
    projectId: string;
}

/**
 * Check if a given object implements the McpConsentApprovalRequest interface.
 */
export function instanceOfMcpConsentApprovalRequest(value: object): value is McpConsentApprovalRequest {
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    return true;
}

export function McpConsentApprovalRequestFromJSON(json: any): McpConsentApprovalRequest {
    return McpConsentApprovalRequestFromJSONTyped(json, false);
}

export function McpConsentApprovalRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): McpConsentApprovalRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'projectId': json['projectId'],
    };
}

export function McpConsentApprovalRequestToJSON(json: any): McpConsentApprovalRequest {
    return McpConsentApprovalRequestToJSONTyped(json, false);
}

export function McpConsentApprovalRequestToJSONTyped(value?: McpConsentApprovalRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'projectId': value['projectId'],
    };
}

